export default function covert(unit, value, unit_default, originalValue) {

    switch (unit_default) {
        case 'R$':
            if (unit !== unit_default) {
                if (unit === 'US$') {
                    return 0.185185185 * originalValue; //REAL PARA DOLLAR
                }
            }
            return originalValue;

        case 't':
            if (unit !== unit_default) {
                if (unit === 'kg/t') {
                    return originalValue * 1000;
                }
                if (unit === 'mg/L') {
                    return originalValue * 100000000;
                }
            }
            return originalValue;

        case 'm³':
            if (unit !== unit_default) {
                if (unit === 'ML') {
                    return  originalValue / 1000;
                }
            }
            return originalValue;

        case 'GJ':
            if (unit !== unit_default) {
                if (unit === 'MWh') {
                    return originalValue / 3.6;
                }
            }
            return originalValue;

        case 'ha':
            if (unit !== unit_default) {
                if (unit === 'ac') {
                    return originalValue * 2.471;
                }
                if (unit === 'km²') {
                    return originalValue / 100;
                }
            }
            return originalValue;

        case 'km²':
            if (unit !== unit_default) {
                if (unit === 'ac') {
                    return originalValue * 247;
                }
                if (unit === 'ha') {
                    return originalValue * 100;
                }
            }
            return originalValue;
        default:
            return originalValue;
    }
}
